import { useEffect, useState } from 'react';

import {
  getFlowStartingPoints,
  getNextPoints,
  findFlowStartingPointNode,
  getParentNodeType,
} from '../../../core';

import { FlowStartingPoint } from '../../types';

export const useFlows = () => {
  const [flows, setFlows] = useState<FlowStartingPoint[]>();
  const [loading, setLoading] = useState(true);

  const isFlowCorrectlyWrapped = async (nodeId: string) => {
    const parentType = await getParentNodeType(nodeId);

    if (!parentType || parentType !== 'SECTION') {
      return false;
    }

    return true;
  };

  const getStartingPoints = async () => {
    const startingPoints = await getFlowStartingPoints();

    setFlows([...startingPoints]);
    setLoading(false);
  };

  const getAllNodeIdsToGenerate = async (
    startingPoint: string,
    dontSkipVariants = false
  ) => {
    const startingNode = await findFlowStartingPointNode(startingPoint);

    const {
      generatedPoints,
      generatedPartialPoints,
      generatedDynamicNodePoints,
      variants,
      globalNodeMap,
      globalTextNodes,
      globalWarnings,
      clonedIdsMap,
      originalIdsMap,
    } = await getNextPoints(
      startingPoint,
      startingNode?.parentNodeId || '',
      dontSkipVariants
    );

    return {
      globalNodeMap,
      startingNode,
      generatedPoints,
      generatedPartialPoints,
      generatedDynamicNodePoints,
      variants,
      globalTextNodes,
      globalWarnings,
      clonedIdsMap,
      originalIdsMap,
    };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getStartingPoints();
    }, 500);

    return () => {
      clearTimeout(interval);
    };
  }, []);

  return {
    flows,
    isFlowCorrectlyWrapped,
    getAllNodeIdsToGenerate,
    loading,
  };
};
